import { useEffect, useState } from 'react';

export type ThemePreference = 'system' | 'light' | 'dark';
const KEY = 'coyg_red_thread_theme';
export function readTheme(): ThemePreference {
  try {
    const value = localStorage.getItem(KEY);
    if (value === 'light' || value === 'dark') return value;
  } catch { /* The site remains usable without device storage. */ }
  return 'system';
}
export function applyTheme(preference: ThemePreference) {
  const dark = preference === 'dark' || (preference === 'system' && window.matchMedia?.('(prefers-color-scheme: dark)').matches);
  document.documentElement.dataset.theme = dark ? 'dark' : 'light';
}
export function ThemeControl() {
  const [preference, setPreference] = useState<ThemePreference>(readTheme);
  useEffect(() => {
    applyTheme(preference);
    const media = window.matchMedia?.('(prefers-color-scheme: dark)');
    const update = () => applyTheme(preference);
    media?.addEventListener?.('change', update);
    return () => media?.removeEventListener?.('change', update);
  }, [preference]);
  return <label className="rt-theme"><span className="sr-only">Colour theme</span><select aria-label="Colour theme" value={preference} onChange={(event) => {
    const next = event.target.value as ThemePreference;
    setPreference(next);
    try { localStorage.setItem(KEY, next); } catch { /* Optional preference. */ }
    applyTheme(next);
  }}><option value="system">System</option><option value="light">Light</option><option value="dark">Dark</option></select></label>;
}
